import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VSelect,{attrs:{"id":"group-solution-select","item-text":"nome","item-name":"grupoSolucaoId","item-value":"grupoSolucaoId","items":_vm.gruopSolutions,"label":_vm.isAT
        ? 'Grupos de Iniciativas'
        : _vm.isGov
        ? 'Grupos de fases'
        : 'Grupos de Soluções',"placeholder":_vm.isAT
        ? 'Grupos de Iniciativas'
        : _vm.isGov
        ? 'Grupos de fases'
        : 'Grupos de Soluções',"clearable":""},on:{"change":function($event){return _vm.$emit('changeGroupSolution', _vm.grupoSolucaoIds)}},model:{value:(_vm.grupoSolucaoIds),callback:function ($$v) {_vm.grupoSolucaoIds=$$v},expression:"grupoSolucaoIds"}},[_c('template',{slot:"no-data"},[_vm._v("\n      Nenhum\n      "+_vm._s(_vm.isAT
          ? "Grupo de Iniciativa"
          : _vm.isGov
          ? "Grupo de Fase"
          : "Grupo de Solução")+"\n      Retornado\n    ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }